import { useContext } from "react";
import { Stack, Typography, Box, useMediaQuery, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PlannerContext } from "../../../../context/planner/PlannerContext";
import EditTimeBlock from "./EditTimeBlock";
import EditActivityBlock from "./EditActivityBlock";
import EditTaskBlock from "./EditTaskBlock";

const EditBlock = () => {
  const {
    blocks,
    selectedBlockId,
    setSelectedTool,
    setSelectedBlockId,
    closeToolPanel,
  } = useContext(PlannerContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const block = blocks[selectedBlockId];

  const handleBack = () => {
    setSelectedBlockId(null);
    setSelectedTool("dayConfig");
    if (isMobile) {
      closeToolPanel();
    }
  };

  if (!block) {
    return (
      <Stack spacing={2}>
        <Typography variant="h3">Edit Block</Typography>
        <Typography variant="body2" color="text.secondary">
          Select a block to edit it
        </Typography>
      </Stack>
    );
  }

  const renderBlockEditor = () => {
    switch (block.type) {
      case "time":
        return <EditTimeBlock block={block} />;
      case "activity":
        return <EditActivityBlock block={block} />;
      case "task":
        return <EditTaskBlock block={block} />;
      default:
        return <Typography>Unknown block type</Typography>;
    }
  };

  const getBlockTypeLabel = () => {
    switch (block.type) {
      case "time":
        return "Time Block";
      case "activity":
        return "Activity Block";
      case "task":
        return "Task Block";
      default:
        return "Block";
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          "&:hover": { opacity: 0.7 },
          mb: 1,
        }}
        onClick={handleBack}
      >
        <ArrowBackIcon sx={{ mr: 1, fontSize: 20 }} />
        <Typography variant="body2" color="text.secondary">
          Back to day config
        </Typography>
      </Box>

      <Typography variant="h3" sx={{ mb: "0 !important" }}>
        Edit {getBlockTypeLabel()}
      </Typography>

      {renderBlockEditor()}
    </Box>
  );
};

export default EditBlock;
